// extracted by mini-css-extract-plugin
module.exports = {"signInMobileLabel":"az_TLc","fixedSignInMobileIconAndLabel":"az_ULc","signInIcon":"az_VLc"};